import { Injectable } from '@angular/core';
import { GoogleChartsService } from './google-charts.service';
import { ColumnChartConfig } from './google-chart.config';

declare var google: any;

@Injectable()
export class GoogleColumnChartsService extends GoogleChartsService {
  constructor() {
    super();
  }

  public BuildColumnCharet(
    elementInDom: any,
    data: any[],
    config: ColumnChartConfig
  ) {
    const chartFunc = () => {
      return new google.visualization.ColumnChart(elementInDom);
    };

    this.buildChart(data, chartFunc, config);
  }
}
